import * as moment from 'moment/moment';

export const disableDatesBeforeNow = (d: Date): boolean => moment(d).isBefore(moment());
